import account from 'Store/CompanyAccount/account'
import building from 'Store/CompanyAccount/building'
import category from 'Store/CompanyAccount/category'
import favorite from 'Store/CompanyAccount/favorite'
import location from 'Store/CompanyAccount/location'
import recharge from 'Store/CompanyAccount/recharge'
import review from 'Store/CompanyAccount/review'
import subscription from 'Store/CompanyAccount/subscription'
import user from 'Store/CompanyAccount/user'
import dashboard from 'Store/CompanyAccount/dashboard'

export default {
  namespaced: true,

  modules: {
    account,
    building,
    category,
    favorite,
    location,
    recharge,
    review,
    subscription,
    user,
    dashboard,
  }
}